import { createReducer } from '@reduxjs/toolkit';
import { HIDE_LOADING_SPINNER, SHOW_LOADING_SPINNER } from '../actions/loading-spinner';

export type LoadingSpinnerState = {
  isLoading: boolean;
  message?: string;
};

const initState: LoadingSpinnerState = {
  isLoading: false,
  message: '',
};

const loadingSpinnerReducer = createReducer(initState, (builder) =>
  builder
    .addCase(SHOW_LOADING_SPINNER, (state, action) => {
      return { ...state, isLoading: true, message: action.payload };
    })
    .addCase(HIDE_LOADING_SPINNER, (state, action) => {
      return { ...state, isLoading: false, message: action.payload };
    })
);

export default loadingSpinnerReducer;
